__turbopack_context__.v({
  "error": "typeahead-module-scss-module__TFW_Uq__error",
  "item-no-match": "typeahead-module-scss-module__TFW_Uq__item-no-match",
  "item-prompt": "typeahead-module-scss-module__TFW_Uq__item-prompt",
  "item-searching": "typeahead-module-scss-module__TFW_Uq__item-searching",
  "menu-title": "typeahead-module-scss-module__TFW_Uq__menu-title",
  "typeahead": "typeahead-module-scss-module__TFW_Uq__typeahead",
  "typeahead-error": "typeahead-module-scss-module__TFW_Uq__typeahead-error",
  "typeahead-item": "typeahead-module-scss-module__TFW_Uq__typeahead-item",
  "typeahead-item-active": "typeahead-module-scss-module__TFW_Uq__typeahead-item-active",
  "typeahead-item-menu": "typeahead-module-scss-module__TFW_Uq__typeahead-item-menu",
});
